import { type JSX } from 'solid-js'
import Css from './filters.module.scss'

/** O botao cheio - a acao principal de um formulario. */
export function Button(props: {
    children: JSX.Element
    type?: 'submit' | 'reset' | 'button'
    disabled?: boolean
    onClick?: () => void
    variant?: 'primary' | 'outline' | 'ghost' | 'danger' | 'glass'
    class?: string
    /**
     * O `<form>` que este botao submete, quando ele nao esta dentro dele.
     *
     * E o que permite o rodape do dialogo ficar preso enquanto o corpo rola, sem o
     * botao perder o comportamento de submeter.
     */
    form?: string
}): JSX.Element {
    const variant = () => props.variant ?? 'primary'

    return (
        <button
            type={props.type ?? 'button'}
            form={props.form}
            disabled={props.disabled}
            onClick={props.onClick}
            class={`${Css.button} ${props.class ?? ''}`}
            classList={{
                [Css.primary]: variant() === 'primary',
                [Css.outline]: variant() === 'outline',
                [Css.ghost]: variant() === 'ghost',
                [Css.danger]: variant() === 'danger',
                [Css.glass]: variant() === 'glass'
            }}
        >
            {props.children}
        </button>
    )
}
